module.exports = __webpack_public_path__ + "img/expand-full.b11e945d.svg";